module.exports = __webpack_public_path__ + "3a041623383aeb93157e72aa09e6e6b4.pdf";